module.exports = __webpack_public_path__ + "media/configurations/SV_X-X-P-f14d14ce.png";